import icon_noti from 'src/assets/images/cancel/cancel_notice_icon.png'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16, Noto_heading3_b20 } from 'src/styles/fonts/NotoSansKrFonts'
import styled from 'styled-components'
import { SystemNoticePageProps } from 'src/pages/SystemNoticePage/index'
import Button, { ButtonOption3 } from 'src/components/common/Button'

const SystemNoticeViewPage = ({ noticeData, appExit }: SystemNoticePageProps) => {
  return (
    <SystemNoticeBoundaryWrap>
      <SystemNoticeContents>
        <SystemNoticeMessageIcon src={icon_noti} alt="!아이콘" />
        <Typography $fontStyle={Noto_heading3_b20}>
          {noticeData?.Title || '시스템 점검 중'}
        </Typography>
        <SystemNoticeDesc $fontStyle={Noto_body1_r16}>
          {noticeData?.Contents || '현재 시스템 점검 중입니다.'}
        </SystemNoticeDesc>
        <Button option={ButtonOption3('active')} onClickFn={appExit}>
          앱 닫기
        </Button>
      </SystemNoticeContents>
    </SystemNoticeBoundaryWrap>
  )
}
export default SystemNoticeViewPage

const SystemNoticeBoundaryWrap = styled.div`
  height: calc(var(--vh, 1vh) * 100);
  background-color: var(--brand-20);
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px;
`

const SystemNoticeContents = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  width: 100%;
  height: auto;
  border-radius: 20px;
  margin: 0 auto;
  gap: 20px;
  background-color: white;
`
const SystemNoticeMessageIcon = styled.img`
  margin: 0 auto;
  width: 40px;
`

const SystemNoticeDesc = styled(Typography)`
  white-space: pre-line;
  text-align: left;
`
